import { http } from "./httpServices";
import { EVENTS } from "./constants";

export function fetchAllEvents(
  activePage: number,
  limitCount: number,
  queryString: string
) {
  return http.get(
    `${EVENTS}?page=${activePage}&limit=${limitCount}&searchText=${queryString}`
  );
}

export function uploadEventImage(data: any) {
  const formData = new FormData();
  formData.append("file", data);
  return http.post(`${EVENTS}/uploadFiles`, formData);
}

export function createEvent(data: {
  title: string;
  description: string;
  location: string;
  // time?: string;
  whatsapp: string;
  phone: string;
  imageUrl: string;
  date: string;
  endDate?: string,
  // endTime?: string,
}) {
  return http.post(EVENTS, data);
}

export function fetchEventDetails(id: string | undefined) {
  return http.get(`${EVENTS}/${id}`);
}

export function updateEvent(
  data: {
    title: string;
    description: string;
    location: string;
    // time: string;
    whatsapp: string;
    phone: string;
    imageUrl: string;
    date: string;
    endDate: string;
    // endTime: string;
  },
  id: string | number | any
) {
  return http.put(`${EVENTS}/${id}`, data);
}

export function fetchAttendessDetails(id: string | undefined) {
  return http.get(`${EVENTS}/attendiescounts/${id}`);
}
